const QUERY_PARAMS_FROM: string[] = ['mainPage', 'header'];

/**
 * Проверяем что пользователь пришел из главной страницы
 * (шапка/табы над фильтрами) - если это так, то запускается кейс
 * попытки миграции данных из оценки в Мой дом
 */
export const checkIsUserFromMainPage = (from?: string) => {
  return Boolean(from && QUERY_PARAMS_FROM.includes(from));
};
